
import React from "react";
import styles from "./AvisoPrivacidad.module.css";
import HomeIcono from "../../components/HomeIcon/HomeIcono";

const AvisoPrivacidad: React.FC = () => {
  
 return (
    <div>
       <HomeIcono></HomeIcono>
      <div  className={styles.container}>
        <h1 className={styles.titles}>AVISO DE PRIVACIDAD</h1>

        Colectivo Siete, con domicilio en De Los Olivos 66, Lázaro Cárdenas, 72805 San Andrés Cholula, Pue., es el responsable del uso y protección de sus datos personales.

        <br/>         <br/> 
        <h2  className={styles.titles}>FINALIDADES PRIMARIAS</h2>
        Los datos personales que recabamos de usted, los utilizaremos para las siguientes finalidades que son necesarias para el servicio que solicita:

        <ul>
          <li>Notificaciones por correo de avisos, eventos y cursos de la comunidad</li>
          <li>Mantener comunicación vía teléfono o mensajería instantánea (WhatsApp)</li>
          <li>Agregarlo a grupos de WhatsApp relacionados con las actividades de la comunidad</li>
        </ul>

        <h2  className={styles.titles}>DATOS PERSONALES RECABADOS</h2>
     
        Para las finalidades señaladas en el presente aviso de privacidad, podemos recabar sus datos de identificación y contacto.

        <br/>         <br/> 
        <h2  className={styles.titles}>DERECHOS ARCO</h2>
        Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones del uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su información personal en caso de que esté desactualizada, sea inexacta o incompleta (Rectificación); que la eliminemos de nuestros registros o bases de datos cuando considere que la misma no está siendo utilizada adecuadamente (Cancelación); así como oponerse al uso de sus datos personales para fines específicos (Oposición). Estos derechos se conocen como derechos ARCO.

        Para el ejercicio de cualquiera de los derechos ARCO, usted deberá presentar la solicitud respectiva a través de los medios especificados. La respuesta a su solicitud será atendida en un plazo máximo de 20 días hábiles.

        <br/>         <br/> 
        <h2  className={styles.titles}>DATOS RECABADOS POR EL SITIO WEB</h2>
        Nuestro sitio web recaba automáticamente los siguientes datos:

        <ul>
          <li>Identificadores, nombre de usuario y contraseñas de sesión</li>
          <li>Correo, teléfono, ciudad de residencia, edad</li>
        </ul>

        <h2  className={styles.titles}>CONTACTO</h2>
        Para más información sobre este aviso de privacidad, puede contactarnos en:

        <p>Correo: <strong>sulamcollective@gmail.com</strong></p>
        <p>Sitio web: <strong> https://colectivosiete.com</strong></p>

        <br/> 
        Última actualización: 01/09/2025
      </div>
    </div>
  );
};

export default AvisoPrivacidad;
